document.addEventListener('DOMContentLoaded', function () {
  const correctPassword = 'moonlight';
  const unlockKey = 'honeydrip_early_access_unlocked';

  function unlockEarlyAccess() {
    sessionStorage.setItem(unlockKey, 'true');

    document.querySelectorAll('[data-early-access-hidden]').forEach(function (el) {
      el.removeAttribute('data-early-access-hidden');
el.style.display = '';
    });

    document.querySelectorAll('[data-early-access-gate]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  if (sessionStorage.getItem(unlockKey) === 'true') {
    unlockEarlyAccess();
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-early-access-submit]');
    if (!button) return;

    const gate = button.closest('[data-early-access-gate]');
    const input = gate.querySelector('[data-early-access-input]');
    const error = gate.querySelector('[data-early-access-error]');

    if (input.value === correctPassword) {
      unlockEarlyAccess();
    } else {
      error.hidden = false;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    const input = event.target.closest('[data-early-access-input]');
    if (!input) return;

    input.closest('[data-early-access-gate]')
      .querySelector('[data-early-access-submit]')
      .click();
  });
});